import { render, staticRenderFns } from "./announcementEdit.vue?vue&type=template&id=6dfedca2&"
import script from "./announcementEdit.vue?vue&type=script&lang=js&"
export * from "./announcementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports